<template>
  <div class="list-panel">
    <div class="main-container">
      <div class="content-wrap">
        <custom-form assess-type="cus" operate-type="show"></custom-form>
      </div>
    </div>
  </div>
</template>

<script>
import CustomForm from "./form";
export default {
  components: {
    CustomForm
  },
  data() {
    return {
      
    }
  },
  methods: {
    onSubmit() {
      this.$refs.endAssessForm.validate(valid => {
        if (valid) {

        }
      })
    }
  }
}
</script>

<style lang="scss">
.form-block {
  position: relative;
  padding-bottom: 20px;

  &.has-divider.top:before {
    content: '';
    position: absolute;
    left: -15px;
    right: -15px;
    top: -15px;
    height: 10px;
    display: block;
    background: #f0f2f5;
    box-shadow: 0 2px 12px 0 rgb(220, 222, 226) inset;
  }
  &.has-divider.bottom:after {
    content: '';
    position: absolute;
    left: -15px;
    right: -15px;
    bottom: 0;
    height: 10px;
    display: block;
    background: #f0f2f5;
    box-shadow: 0 2px 12px 0 rgb(220, 222, 226) inset;
  }

  .title {
    margin: 5px 0;
    font-size: 14px;
  }
  .divider {
    margin: 8px 0 10px;
  }

  &-submit {
    padding-top: 15px;
    text-align: center;
  }
  
  .block-form-item {
    &.w-25 {
      display: inline-block;
      width: 24%;
      margin-right: 1%;
      height: 64px;
    }

    &.w-99 {
      width: 99%;
      margin-right: 1%;
    }
  }
}
</style>

